import Vue from 'vue'
import Router from 'vue-router'

import PageStart from '@/components/PageStart'
import PageOne from '@/components/PageOne'
import PageTwo from '@/components/PageTwo'
import PageRecipes from '@/components/PageRecipes'
import PageNews from '@/components/PageNews'
import PagePrelast from '@/components/PagePrelast'
import PageScore from '@/components/PageScore'
import PageMobile from '@/components/PageMobile'
import NotFoundComponent from '@/components/NotFoundComponent'

Vue.use(Router);
let langUrl = 'ru';
let langUrlEn = 'en';

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/' + langUrl,
            name: 'StartRu',
            component: PageStart
        },
        {
            path: '/' + langUrl + '/Mobile', 
            name: 'MobileRu',
            component: PageMobile
        },
        {
            path: '/' + langUrl + '/One', 
            name: 'OneRu',
            component: PageOne
        },
        {
            path: '/' + langUrl + '/Two', 
            name: 'TwoRu',
            component: PageTwo
        },
        {
            path: '/' + langUrl + '/Recipes', 
            name: 'RecipesRu',
            component: PageRecipes
        },
        {
            path: '/' + langUrl + '/News', 
            name: 'NewsRu',
            component: PageNews
        },
        {
            path:  '/' + langUrl + '/Prelast', 
            name: 'PrelastRu',
            component: PagePrelast
        },
        {
            path: '/' + langUrlEn,
            name: 'StartEn',
            component: PageStart
        },
        {
            path: '/' + langUrlEn + '/Mobile', 
            name: 'MobileEn',
            component: PageMobile
        },
        {
            path: '/' + langUrlEn + '/One', 
            name: 'OneEn',
            component: PageOne
        },
        {
            path: '/' + langUrlEn + '/Two', 
            name: 'TwoEn',
            component: PageTwo
        },
        {
            path: '/' + langUrlEn + '/Recipes', 
            name: 'RecipesEn',
            component: PageRecipes
        },
        {
            path: '/' + langUrlEn + '/News', 
            name: 'NewsEn',
            component: PageNews
        },
        {
            path:  '/' + langUrlEn + '/Prelast', 
            name: 'PrelastEn',
            component: PagePrelast
        },
        {
            path: '/' + langUrlEn + '/Score', 
            name: 'Score',
            component: PageScore
        },
        { 
            path: '*', 
            component: NotFoundComponent 
        },
    ]
})  

if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
    router.beforeEach((to, from, next) => {
        if (to.name === 'OneRu' || to.name === 'OneEn') {
            setTimeout(() => {
                document.querySelector('.nav_container').style.display = 'none'     
            }, 0);
            next() 
        } else {
            setTimeout(() => {
                document.querySelector('.nav_container').style.display = 'block'     
            }, 0);
            next()
        }
    })
}

export default router


